import { PersonToMeInstructionContainer } from '../containers/PersonToMeInstructionContainer/index'

export const PersonToMeInstructionPage = () => (
    <PersonToMeInstructionContainer/>
)